import { useMutation } from 'react-query';
import { generateManagerialIncome } from './Managerial.service';
import { notification } from 'antd';
import reportNotificationError from '@/utils/functions/notificationErrorNetReport';

export function useManagerialIncome() {
  const mutation = useMutation(generateManagerialIncome, {
    onSuccess() {
      notification.success({
        message: 'Sucesso',
        description: 'Relatório de Faturamento gerado com sucesso!',
      });
    },

    onError(error) {
      reportNotificationError(error);
    },
  });

  return mutation;
}
